//Prevent click/tap on navigation dropdown menu items on touch screen
/*Re-enabled 9/3/21 by Tim - Requested by Monique
if ('ontouchstart' in window) {
	$(".dropdown--parent-link").click(function (e) {
		e.preventDefault();
	});
}*/

// Fixed Header
header = $('#shopify-section-header')
header_height = header.height()
header_bar_height = 0	

function updatePadding(){
	header_bar_height = 0
	header_height = header.height()
	slider_height = $(window).height() - header_height 
	$('.main-content').css('padding-top', header_height );
	$('.mega-nav').css('top', header_height - 15 );
	
	$('.home-slider .slide-container').css('max-height',slider_height+'px')
	$('.page-header.img').css('max-height',slider_height+'px')
}


/*===== LAZYLOAD IMAGES =====*/
$("img.lazyload").lazyload();


/*===== PRODUCT IMAGE HOVER =====*/
var SecondImageRollovers = new function(){  
	this.initRollovers = function(){
		$(".product-grid-item img").hover(function() {
			if($(this).data("image2")){
				$(this).attr("src", $(this).data("image2"));
			}
		},function() {
			$(this).attr("src", $( this).data("image1"));
		});
	}
}

SecondImageRollovers.initRollovers();


/*===== FADE IN CONTENT ON SCROLL =====*/
// Changing the defaults
window.sr = ScrollReveal({ reset: false });
// Customizing a reveal set
sr.reveal('.fadein', { duration: 2000, scale: 1, distance: '0px', interval:200 });
sr.reveal('.fadeup', { duration: 1000, scale: 1, distance: '50px', interval:200 }); 

sr.reveal('.collection-wrapper, .grid__item.product-grid-item, .home-split-img-text', { duration: 1000, scale: 1, distance: '50px', interval:200 }); 


/*===== HEADER / NAVIGATION =====*/

$('.has-mega .dropdown--parent-link').click(function(e){
	e.preventDefault();
});

/*===== VIDEOS =====*/
$('.section-video .play').click(function(){
	$(this).parent('.section-video').find('video').trigger('play');
	$(this).parent('.section-video').find('.pause').show();
	$(this).hide();
});

$('.section-video .pause').click(function(){
	$(this).parent('.section-video').find('video').trigger('pause');
	$(this).parent('.section-video').find('.play').show();
	$(this).hide();
}); 

$('.section-video .sound').click(function(){
	$(this).parent('.section-video').find('video').prop('muted', false);
	$(this).parent('.section-video').find('.mute').show();
	$(this).hide();
});

$('.section-video .mute').click(function(){
	$(this).parent('.section-video').find('video').prop('muted', true);
	$(this).parent('.section-video').find('.sound').show();
	$(this).hide();
});

//Autoplay Videos
if ($(window).width() < 480) {
	$('.autoplay').find('video.large--hide').trigger('play'); 
} else {
	$('.autoplay').find('video.small--hide').trigger('play');
}

//For paused videos, display control when initially played
$('.section-video.paused .play').click(function(){
	$(this).parent('.section-video').find('.mute').show();
	$(this).removeClass('paused');
});


/*===== POPUPS =====*/

//Close popups
$(".close-popup").click(function(e) {
	$(this).closest('.popup-wrapper').fadeOut();
});

//Cookies for popup 

$(document).ready(function() {
	function setCookie(cname,cvalue,exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires=" + d.toGMTString();
		document.cookie = cname+"="+cvalue+"; "+expires+"; domain=.doseandco.com; path=/";
	}

	function getCookie(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i<ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1);
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	} 
	
	nz_countries = 'NZ'
	au_countries = 'AU'
	us_countries = 'CA US' 
	uk_countries = 'GB' 
	
	var geo_cookie = 'geo-location-v3'
	
	var region = getCookie(geo_cookie);

	function storeDetection(region) {
		if (store_location != region ) {
			//If we have a saved GEO location cookie but the customer is on the wrong store
			
			if ( getCookie(geo_cookie) == 'AU' ) {
				$('#prefered-store, #cust-country-name').html('Australia')
				$('.store-selector').data('region','AU')
			} else if ( getCookie(geo_cookie) == 'NZ' ) {
				$('#prefered-store, #cust-country-name').html('New Zealand')
				$('.store-selector').data('region','NZ')
			} else if ( getCookie(geo_cookie) == 'UK' ) {
				$('#prefered-store, #cust-country-name').html('United Kingdom')
				$('.store-selector').data('region','UK')
			} else {
				$('#prefered-store, #cust-country-name').html('United States')
				$('.store-selector').data('region','US')
			}
	
			$('#store-selector').fadeIn();
		}
	}

	if ( region == ''){
		//If we dont have a saved geo location cookie
		var request = new XMLHttpRequest();
		request.onreadystatechange = function() {
			if (request.readyState === 4 && request.status === 200) {
				var json = JSON.parse(request.responseText);
		
				customer_geo_code = json['location']['country']['code']
						
				if (au_countries.indexOf(customer_geo_code) >= 0) {
					region = 'AU'; 
				} else if (us_countries.indexOf(customer_geo_code) >= 0) { 
					region = 'US'; 
				} else if (uk_countries.indexOf(customer_geo_code) >= 0) { 
					region = 'UK'; 
				} else if (nz_countries.indexOf(customer_geo_code) >= 0) { 
					region = 'NZ';				
				} else {
					region = customer_geo_code;				
				} 

				setCookie(geo_cookie, region, 90000);
				storeDetection(region);
			}
		};
		request.open('GET', 'https://api.ipregistry.co/?key=5swy0ibic4iyed', true);
		request.send(null);
	} else {
		
		console.log('data saved')
		
		storeDetection(region);
	}
		

	function storeSelection(region) {
		if ( store_location == region ) {
			$('#store-selector').fadeOut()
		} else {
			new_url = 'https://'+region+'.doseandco.com'
			pathname = window.location.pathname + window.location.search; // Returns path only
	
			window.top.location.href = new_url + pathname.split('?')[0];
		}
	}

	$('.store-selector').on('click', function(e) {
		e.preventDefault(); 
		region = $(this).data('region');
		setCookie(geo_cookie, region, 90000); 
		storeSelection(region);
	});
 
	$('.shopify-currency-form select').change(function(e) {
		e.preventDefault();
		region = $(this).val();
		setCookie(geo_cookie, region, 90000); 
		storeSelection(region);
	});  
	

	$('.close-store-selector').click(function(e) {
		e.preventDefault();
		setCookie(geo_cookie, $(this).data('region'), 90000);
		$('#store-selector').fadeOut();
	});

	pageCount = getCookie("page-count");
	newsletter_viewed = getCookie('newsletter-popup-viewed');				
	dairyfree_viewed = getCookie('dairyfree-popup-viewed');				


	if (pageCount != "") {
		pageCount = parseInt(pageCount) + 1
	} else {
		pageCount = 1
	}		  
	setCookie("page-count", pageCount, 1);

	if (newsletter_viewed != 'yes') {
		if (pageCount == 3) {
			$('#newsletter-popup').fadeIn();
		}
	}
	
	$('#newsletter-popup .close-popup, #close-newsletter-popup').click(function(){
		setCookie("newsletter-popup-viewed", 'yes', 5);
		$('#newsletter-popup').fadeOut();
	});


	/*===== HEADER/NAV =====*/

	if (getCookie('header-message') != 'closed') {
		$('#header-banner').css('display','inline-block');	
	
		header_height = $('#shopify-section-header').outerHeight()				
	}

	$('#close-message').click(function(e){
		e.preventDefault();
		$('#header-banner').hide();
		setCookie('header-message', 'closed', 1);
	
		header_height = $('#shopify-section-header').outerHeight()	
		updatePadding();
	});

	/* NAVIGATION */
	var MobileMenu = function(){	
		$.fn.setTransX = function(x){
      
			var trans = "translateX(" + x + ")";
			$(this).css({
				"-webkit-transform":trans,
				"-ms-transform":trans,
				"transform":trans
			});
		} 
  
		$("#mobile-menu .has-children a span").not('#mobile-menu .no-children a span').click(function(e){
			e.preventDefault();
			nextMenu($(this));
		}); 
		
		$("#mobile-menu .has-children .back-to-parent").click(function(e){
			e.preventDefault();
			previousMenu($(this));
		});
	
		function nextMenu(selection){
			var uls = selection.closest("li").find("ul");
			uls.hide();
			uls.eq(0).show();
			var offset = selection.parents('nav ul').length * -100;
			selection.closest("nav").setTransX(offset + "%");
		}
	
		function previousMenu(selection){      
			var nav = selection.closest("nav");
			var ul = selection.closest("ul"); 
      
			var offset = Math.min(0 , (selection.parents('nav ul').length-2) * -100);
      
			nav.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
				console.log("back animation complete");
				$(this).off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
				ul.removeAttr('style');
			});
      
			nav.setTransX(offset + "%");
		}
	} 

	new MobileMenu();

	if ($(window).width() > 1001) {
		if (getCookie('header-message') != 'closed') {	
			header_bar_height = $('#header-banner').height()
		} else {
			header_bar_height = 0	
		} 
	
		$('.main-content').css('padding-top', header_height);
	
		$(document).scroll(function() {
			scroll_top = $(this).scrollTop()
			scroll_top_negative = -Math.abs( scroll_top )
		
			if ( scroll_top < header_bar_height ) {
				header.css( 'top', scroll_top_negative );
				//header.removeClass('fixed');
			} else {
				header.css( 'top', -Math.abs( header_bar_height ) );
				//header.addClass('fixed');
			}
		});
	}

	/*===== HOMEPAGE SCRIPTS =====*/
	if ( window.location.pathname != '/' ){
	}

	/*===== MOBILE SCRIPTS =====*/


	if ($(window).width() < 1001) {
		
		$('#mobile-menu').css({ 'height': 'calc(100vh - ' + header_height+ 'px)' });

		$('.site-header').on('click', '#open-mobile-menu', function() {
			if ( $(this).hasClass('is-active') ) {
				$(this).removeClass('is-active')
				$('#mobile-menu').css('top', '-110vh' );

			} else {
				$(this).addClass('is-active')
				$('#mobile-menu').css('top', header_height );
			}
		});
	}

	if ($(window).width() < 480) {
	
		$("#ProductMobileGallery").owlCarousel({
			items:1,
			nav:false,
			autoplay:false,
			dots:true,
			autoplaySpeed: 2000,
			smartSpeed: 500,
			loop:true,
			autoplayTimeout:5000,
			lazyLoad: true,
			lazyLoadEager: 1
		});
	}

	/*===== COLLECTION SCRIPTS =====*/
	$('.trigger-filter').click(function(){
		$('.collection-filter ul').fadeToggle();
	});


	/*===== PRODUCT SCRIPTS =====*/

	var acc = document.getElementsByClassName("accordion");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function() {
			this.classList.toggle("active");
			var panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});
	}

	$('.accordion.active').each(function(i) {
		var panel = this.nextElementSibling;
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = "2000px";
		}
	});


	/*===== SEARCH =====*/


	$('#search-icon').click(function(e){
		e.preventDefault();
		$('#desktop-search').addClass('active')
	});

	$('#desktop-search .close').click(function(e){
		e.preventDefault();
		$('#desktop-search').removeClass('active');	
		$('.search-results').slideUp();	
	});

	$(function ajax_search() {
	
		// Current Ajax request.
		var currentAjaxRequest = null;
		// Grabbing all search forms on the page, and adding a .search-results list to each.
		var searchForms = $('#desktop-search form[action="/search"]').css('position','relative').each(function() {
			// Grabbing text input.
			var input = $(this).find('input[name="q"]');
			// Adding a list for showing search results.
			var offSet = input.innerHeight();
			$('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide(); 	   
			// Listening to keyup and change on the text field within these search forms.
			input.attr('autocomplete', 'off').bind('keyup change', function() {
				// What's the search term?
				var term = $(this).val(); 
				// What's the search form?
				var form = $(this).closest('form');
				// What's the search URL?
				var searchURL = '/search?type=product&q=' + term;
				// What's the search results list?
				var resultsList = form.find('.search-results');
				// If that's a new term and it contains at least 3 characters.
				if (term.length > 2 && term != $(this).attr('data-old-term')) {
					// Saving old query.
					$(this).attr('data-old-term', term);
					// Killing any Ajax request that's currently being processed.
					if (currentAjaxRequest != null) currentAjaxRequest.abort();
					// Pulling results.
					currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
						// Reset results.
						resultsList.empty();
						// If we have no results.
						if(data.results_count == 0) {
							// resultsList.html('<li><span class="title">No results.</span></li>');
							// resultsList.fadeIn(200);  
							resultsList.hide();
		
							//Search status messages
							$('#searching-animation').fadeOut('fast');
							$('#no-results').fadeIn('fast');
							console.log('no results');
		
		
						} else {
							// If we have results.
							//Search status messages
							$('#searching-animation').fadeOut('fast');
							$('#no-results').fadeIn('fast');
							console.log('results found');
		  
							//Add a nice heading
							resultsList.append('<li class="results-heading"><h4>Top Results</h4></li>');    
		  
							var availableResults = 0
		  		  
							$.each(data.results, function(index, item) {
			  
								//console.log(item.url+' price: '+item.price_clean+'sale: '+item.compare_at_price_clean+'onsale:'+onSale);
			  
								if ( $.isEmptyObject(item) ) { 
									// If product is empty skip
									// Use this to hide soldout items:
									//( ($.isEmptyObject(item)) || (item.availability == 'soldout' ))									
								} else {
									//console.log('found: '+item.title)
									
									var link = $('<a></a>').attr('href', item.url);
									link.append('<div class="grid__image"><img src="' + item.thumbnail + '" /></div>');
									link.append('<p class="title">' + item.title + '</p>');
									link.wrap('<li class="product-grid-item"></li>');
									resultsList.append(link.parent());
				  
									availableResults = availableResults + 1
								}
							});

							// The Ajax request will return at the most 10 results.
							// If there are more than 10, let's link to the search results page.			  
							if(data.results_count > 10) {
								resultsList.append('<li class="view-all-results"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></li>');
							}
							resultsList.fadeIn(200);
		
							if (availableResults == 0) {
								$('.results-heading').slideUp('fast');
								$('#no-results').slideDown('fast');
			
							} else {
								$('.results-heading').slideDown('fast');
								$('#no-results').slideUp('fast');
							}
						}    		      
					});
				}
			});
		});
	});		


	$('#accept-marketing').change(function() {
		if(this.checked) {
			$('#send-contact-form').prop("disabled", false);
		} else {
			$('#send-contact-form').prop("disabled", true);    	
		}
	});

});

$(document).ready(function() {
	updatePadding();
});

$('.klaviyo-signup').submit(function(e) {
	e.preventDefault();
					  
	$(".error").remove();
	hasError = false
	
	k_form = $(this)
	k_email = $(this).find(".k_email")
			  
	var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	var emailaddressVal = k_email.val();

	if (emailaddressVal == '') {
		error_message = 'Please enter an email address'
		k_email.closest('.input-group').after('<p class="error">Please enter your email address.</p>');
		hasError = true;
	} else if (!emailReg.test(emailaddressVal)) {
		k_email.closest('.input-group').after('<p class="error">Enter a valid email address.</p>');
		hasError = true;
	}
  
	if ( hasError == false ) {	 
		$.ajax({
			async: true,
			crossDomain: true,
			url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
			method: "POST",
			headers: {
				"content-type": "application/x-www-form-urlencoded",
				"cache-control": "no-cache"
			},
			data: {
				g: klaviyo_list,
				email: k_email.val()
			}, 
			success: function(response){
				console.log(response)
				
				k_email.closest('.input-group').after('<p class="success">Congrats, you have successfully signed up.</p>')
			}
		});
  
	}
});	

